function Boat() {
  return (
    <svg
      className="boat-illustration"
      viewBox="0 0 292 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M291.413 78.8578L291.36 78.8042C286.613 75.6409 282.933 71.1907 280.693 65.9364L278.346 60.2531C277.173 57.4114 274.506 55.4812 271.466 55.1595L205.172 48.7792C204.745 48.7256 204.425 48.4575 204.318 48.0286L196.158 12.5884C195.998 11.9987 196.478 11.4089 197.118 11.4089H229.759C230.292 11.4089 230.772 10.98 230.719 10.3902L230.505 2.34779C230.505 1.86524 230.079 1.43631 229.599 1.3827C222.505 0.846539 172.851 -2.47765 113.223 3.63457H113.17C112.636 3.7418 105.17 5.13582 104.156 10.2293C104.05 10.8191 104.53 11.4089 105.116 11.4089H111.516C112.423 11.4089 112.85 12.5884 112.103 13.1246L82.9292 36.7693C82.7692 36.9301 82.5559 36.9837 82.3425 36.9837H43.2484C41.8617 36.9837 40.7417 38.1097 40.7417 39.5037V43.1496C40.7417 43.6857 40.3151 44.1147 39.7817 44.1147L5.11438 43.9538C4.58104 43.9538 4.15436 44.3827 4.15436 44.9189C4.15436 46.0984 5.06105 47.0635 6.23441 47.1708L264.799 68.3491C267.2 68.5635 269.333 69.9576 270.453 72.1558L271.52 74.3005C273.973 79.1795 277.493 84.1122 282.933 84.1122L290.88 85.1845C291.467 85.2381 292 84.8092 292 84.2194V79.5548C291.84 79.3404 291.68 79.0723 291.413 78.8578Z"
        fill="#CAD7DE"
      />
      <path
        d="M205.172 48.7792C204.745 48.7256 204.425 48.4575 204.318 48.0286L196.158 12.5884C195.998 11.9987 196.478 11.4089 197.118 11.4089H229.759C230.292 11.4089 230.772 10.98 230.719 10.3902L230.505 2.34779C230.505 1.86524 230.079 1.43631 229.599 1.3827C222.505 0.846539 172.851 -2.47765 113.223 3.63457H113.17C112.636 3.7418 105.17 5.13582 104.156 10.2293C104.05 10.8191 104.53 11.4089 105.116 11.4089H111.516C112.423 11.4089 112.85 12.5884 112.103 13.1246L82.9292 36.7693C82.7692 36.9301 82.5559 36.9837 82.3425 36.9837H43.2484C41.8617 36.9837 40.7417 38.1097 40.7417 39.5037V43.1496C40.7417 43.6857 40.3151 44.1147 39.7817 44.1147L5.11438 43.9538C4.58104 43.9538 4.15436 44.3827 4.15436 44.9189C4.15436 46.0984 5.06105 47.0635 6.23441 47.1708L264.799 68.3491C267.2 68.5635 269.333 69.9576 270.453 72.1558L271.52 74.3005C273.973 79.1795 277.493 84.1122 282.933 84.1122L290.88 85.1845C291.467 85.2381 292 84.8092 292 84.2194V79.5548"
        fill="#CAD7DE"
      />
      <path
        d="M120.85 12.6421L92.7427 37.091C92.156 37.6271 91.356 37.8416 90.6093 37.788L87.2493 37.4663C86.5029 37.4127 86.2359 36.4476 86.8226 35.965L116.53 11.7842C116.85 11.5161 117.277 11.3553 117.65 11.3553H120.37C121.01 11.4089 121.33 12.2131 120.85 12.6421Z"
        fill="white"
      />
      <path
        d="M113.01 25.2418C113.01 25.2418 61.1688 18.7007 3.94101 19.5049C1.5943 19.5585 0.207614 22.1321 1.48764 24.1159L18.0746 49.369"
        stroke="#5E879C"
        strokeWidth="1.19446"
      />
      <path
        d="M44.6352 20.0411L61.8088 53.0149"
        stroke="#5E879C"
        strokeWidth="1.19446"
      />
      <path
        d="M85.1159 22.3466L103.143 55.8566"
        stroke="#5E879C"
        strokeWidth="1.19446"
      />
      <path
        d="M179.624 11.9987L185.278 43.364C185.598 45.187 184.105 46.7954 182.345 46.581L99.3029 38.5922C98.2362 38.485 97.8095 37.1446 98.6096 36.4475L125.917 12.1595C126.503 11.677 127.197 11.4089 127.943 11.4089H178.931C179.251 11.4089 179.571 11.677 179.624 11.9987Z"
        fill="white"
      />
      <path
        d="M290.72 85.1845L281.173 82.7182C277.706 81.8067 274.773 79.4476 273.173 76.2306L271.146 72.1558C269.76 69.4214 267.093 67.5984 263.999 67.3304L5.86102 47.2244L36.2083 83.8977C49.8086 100.304 69.5956 110.277 90.8227 111.295L287.093 120.946C289.707 121.054 291.893 118.963 291.893 116.335V86.6321C291.84 85.9351 291.36 85.3453 290.72 85.1845Z"
        fill="#94AEBE"
      />
      <path
        d="M36.1016 83.8441L31.1949 77.9464C34.8216 82.2892 87.0893 107.81 287.627 120.946C287.36 121 287.147 121 286.88 121L90.8227 111.349C69.5956 110.277 49.7552 100.304 36.1016 83.8441Z"
        fill="#5E879C"
      />
      <path
        d="M23.5148 68.6171C23.5148 68.6171 115.303 98.6421 291.84 109.687V101.966C133.224 94.2456 20.6881 65.1857 20.6881 65.1857L23.5148 68.6171Z"
        fill="#CAD7DE"
      />
      <path
        d="M233.279 77.9463C233.279 72.263 228.692 67.5984 222.985 67.5984C217.332 67.5984 212.692 72.2094 212.692 77.9463C212.692 83.6832 217.278 88.2942 222.985 88.2942C228.639 88.2406 233.279 83.6296 233.279 77.9463ZM222.985 84.4339C219.412 84.4339 216.478 81.5386 216.478 77.8927C216.478 74.3004 219.359 71.3516 222.985 71.3516C226.559 71.3516 229.492 74.2468 229.492 77.8927C229.492 81.5386 226.559 84.4339 222.985 84.4339Z"
        fill="#DFEDF7"
      />
      <path
        d="M223.252 71.4052L224.905 66.3653L228.265 67.4912L226.612 72.5311C225.652 71.8341 224.479 71.4588 223.252 71.4052Z"
        fill="#F50002"
      />
      <path
        d="M216.532 77.6783L211.518 76.0162L212.638 72.6384L217.652 74.3005C216.959 75.2656 216.532 76.4451 216.532 77.6783Z"
        fill="#F50002"
      />
      <path
        d="M229.439 78.1608L234.452 79.8229L233.332 83.2007L228.319 81.5386C229.012 80.6272 229.385 79.4476 229.439 78.1608Z"
        fill="#F50002"
      />
      <path
        d="M222.719 84.4339L221.065 89.4738L217.705 88.3479L219.358 83.308C220.318 84.005 221.492 84.3803 222.719 84.4339Z"
        fill="#F50002"
      />
      <path
        d="M104.103 10.2293C105.116 5.13582 112.583 3.7418 113.117 3.63457H113.17C172.851 -2.47765 222.452 0.846539 229.545 1.3827C230.025 1.43631 230.452 1.81163 230.452 2.34779L230.505 4.11712C230.505 4.11712 199.358 -1.6198 116.263 4.54604C116.263 4.54604 106.876 5.13582 104.103 10.2293Z"
        fill="#F7F7F7"
      />
    </svg>
  );
}

export default Boat;
